import { createContext, useContext } from 'react';

import { IOffer } from '../types/offers';

export type TOfferContext = { offer: IOffer; position: number };

export const OfferContext = createContext<TOfferContext | null>(null);

export function useOfferContext() {
  return useContext(OfferContext) as TOfferContext;
}
